"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideNav = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
;
var SideNav = function (_a) {
    var links = _a.links, _b = _a.customClasses, customClasses = _b === void 0 ? "" : _b;
    return (react_1.default.createElement("div", { className: "axxes-sidenav ".concat(customClasses) }, links === null || links === void 0 ? void 0 : links.map(function (link, index) { return (react_1.default.createElement(react_router_dom_1.Link, { key: index, className: "axxes-navList", to: link.url },
        link.icon && react_1.default.createElement("i", { className: "axxes-icons axxes-navList__icon axxes-icon-".concat(link.icon) }),
        react_1.default.createElement("span", { className: "axxes-navList__content" }, link.title))); })));
};
exports.SideNav = SideNav;
